<style scoped>

.tile_wrapper:hover {
    background-color: #797575;
    cursor: pointer;
}

.sub_title_wrapper {
    background-color: #f4f7f8;
}

.pointer {
    cursor: pointer;
}

#navside{
  background-color: #015599;
}

</style>

<template>

<v-navigation-drawer dark v-model="drawer" :mini-variant="miniVariant" :clipped="clipped" fixed :right="locale === 'he' ? true : false" id="navside">
    <v-layout row wrap class="px-3 py-3">
        <h2 class="white--text">{{content.title}}</h2>
        <v-spacer></v-spacer>
        <v-icon color="dark" @click="drawer = false">cancel</v-icon>
    </v-layout>
    <v-list class="py-0">
        <template v-for="(item, index) in items">
            <v-divider v-if="item.status" :key="index"></v-divider>
            <v-list-tile v-if="item.status" :key="item.title" class="tile_wrapper" @click="openSub(item)" :style="openedMenu == item.title ? 'background-color:#d0dfe7' : ''">
                <v-list-tile-content class="dark--text">
                    <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                    <v-icon color="grey--text lighten-4">{{ item.action }}</v-icon>
                </v-list-tile-action>
            </v-list-tile>
            <v-divider v-else-if="item.divider" :key="index"></v-divider>
            <v-subheader v-else-if="item.header" :key="item.header" class="grey--text text--lighten-4">{{ item.header }}</v-subheader>
            <template v-if="openedMenu == item.title" class="subtitles_wrapper">
                <v-list v-for="sub in item.items" :key="sub.title" class="py-0 sub_title_wrapper">
                    <v-divider></v-divider>
                    <v-list-tile class="tile_wrapper pl-3">
                        <v-list-tile-content class="dark--text" @click="changeRoute(sub.to)">
                            <v-list-tile-title>{{ sub.title }}</v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                </v-list>
            </template>
        </template>
    </v-list>
</v-navigation-drawer>

</template>

<script>

export default {
    data() {
            return {
                locale: null,
                clipped: true,
                drawer: false,
                fixed: false,
                openedMenu: null,
                miniVariant: false
            };
        },
        created() {
            EventBus.$on("sidebar", e => {
                this.drawer = !this.drawer;
            });
            this.locale = Lang.get();
            this.setLang();
        },
        methods: {
            openSub(item) {
                    if (item.to) {
                        this.openedMenu = null;
                        this.$router.push(item.to);
                        this.drawer = false;
                    } else {
                        if (this.openedMenu == item.title) {
                            this.openedMenu = null;
                        } else {
                            this.openedMenu = item.title;
                        }
                    }
                },
                changeRoute(route) {
                    // console.log(route, 1);
                    this.$router.push(route);
                },
                openMenu() {
                    document.getElementById("menuBtn").click();
                },
                setItems(){
                  this.items = [{
                      action: "home",
                      title: this.content.links.home,
                      to: "/",
                      status: Auth.logged()
                  }, {
                      action: "storage",
                      title: this.content.links.logs,
                      to: "/logs",
                      status: Auth.logged()
                  },{
                      action: "settings",
                      title: this.content.links.settings,
                      to: "/profile/settings",
                      status: Auth.logged()
                  },{
                      action: "power_settings_new",
                      title: this.content.links.signout,
                      to: "/logout",
                      status: Auth.logged()
                  }, ];
                },
                setLang() {
                    if (this.locale == "en") {
                        this.content = {
                          title: 'Menu',
                          links: {
                            home: 'Home',
                            signin: 'Sign In',
                            signup: 'Sign Up',
                            new: 'New Device',
                            profile: 'Profile',
                            logs: 'Logs',
                            settings: 'Settings',
                            notifications: 'Notifications History',
                            signout: 'Sign Out',
                          },
                        };
                    } else if (this.locale == "he") {
                        this.content = {
                          title: 'תפריט',
                          links: {
                            home: 'דף הבית',
                            signin: 'התחברות',
                            signup: 'הרשמה',
                            new: 'יחידה חדשה',
                            profile: 'פרופיל',
                            logs: 'לוגים',
                            settings: 'הגדרות',
                            notifications: 'היסטוריית התראות',
                            signout: 'התנתק',
                          },
                        };
                    }
                    this.setItems();
                }
        }
};

</script>
